@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.payments.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.payments.generated.resources/"

public val Res.string.feature_payments_history: StringResource by lazy {
      StringResource("string:feature_payments_history", "feature_payments_history", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 10, 48),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 10, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 48),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 56),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 10, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10, 48),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 10, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 44),
      ))
    }

public val Res.string.feature_payments_inter_bank_transfer_description: StringResource by lazy {
      StringResource("string:feature_payments_inter_bank_transfer_description", "feature_payments_inter_bank_transfer_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 59, 156),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 67, 212),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 59, 136),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 67, 204),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 55, 116),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 59, 120),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 55, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55, 112),
      ))
    }

public val Res.string.feature_payments_inter_bank_transfer_title: StringResource by lazy {
      StringResource("string:feature_payments_inter_bank_transfer_title", "feature_payments_inter_bank_transfer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 216, 90),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 280, 182),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 172, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 196, 82),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 272, 122),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 172, 74),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 180, 90),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 176, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168, 78),
      ))
    }

public val Res.string.feature_payments_intra_bank_transfer_description: StringResource by lazy {
      StringResource("string:feature_payments_intra_bank_transfer_description", "feature_payments_intra_bank_transfer_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 307, 156),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 463, 248),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 279, 128),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 395, 228),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 247, 120),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 271, 116),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 259, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247, 116),
      ))
    }

public val Res.string.feature_payments_intra_bank_transfer_title: StringResource by lazy {
      StringResource("string:feature_payments_intra_bank_transfer_title", "feature_payments_intra_bank_transfer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 464, 90),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 712, 178),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 380, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 408, 82),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 624, 130),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 368, 74),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 388, 90),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 384, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 364, 78),
      ))
    }

public val Res.string.feature_payments_mobile_number: StringResource by lazy {
      StringResource("string:feature_payments_mobile_number", "feature_payments_mobile_number", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 555, 86),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 891, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 467, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 491, 62),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 755, 82),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 443, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 479, 66),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 467, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 443, 58),
      ))
    }

public val Res.string.feature_payments_receive: StringResource by lazy {
      StringResource("string:feature_payments_receive", "feature_payments_receive", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 642, 48),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 978, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 534, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 554, 44),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 838, 80),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 498, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 546, 44),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 526, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 502, 44),
      ))
    }

public val Res.string.feature_payments_request: StringResource by lazy {
      StringResource("string:feature_payments_request", "feature_payments_request", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 691, 40),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1051, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 579, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 599, 44),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 919, 76),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 539, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 591, 44),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 567, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 547, 44),
      ))
    }

public val Res.string.feature_payments_select_transfer_type_header: StringResource by lazy {
      StringResource("string:feature_payments_select_transfer_type_header", "feature_payments_select_transfer_type_header", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 732, 128),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1128, 184),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 624, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 644, 124),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 996, 172),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 580, 112),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 636, 112),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 608, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 592, 108),
      ))
    }

public val Res.string.feature_payments_select_transfer_type_subtitle: StringResource by lazy {
      StringResource("string:feature_payments_select_transfer_type_subtitle", "feature_payments_select_transfer_type_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 861, 114),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1313, 190),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 745, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 769, 118),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1169, 162),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 693, 94),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 749, 114),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 709, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 701, 94),
      ))
    }

public val Res.string.feature_payments_send: StringResource by lazy {
      StringResource("string:feature_payments_send", "feature_payments_send", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 976, 45),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1504, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 868, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 888, 41),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1332, 49),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 788, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 864, 37),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 812, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 796, 37),
      ))
    }

public val Res.string.feature_payments_show_code: StringResource by lazy {
      StringResource("string:feature_payments_show_code", "feature_payments_show_code", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1022, 62),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1554, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 906, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 930, 58),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1382, 74),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 826, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 902, 54),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 850, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 834, 46),
      ))
    }

public val Res.string.feature_payments_transfer_options_title: StringResource by lazy {
      StringResource("string:feature_payments_transfer_options_title", "feature_payments_transfer_options_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1085, 83),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1625, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 961, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 989, 75),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1457, 111),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 881, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 957, 83),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 905, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 881, 71),
      ))
    }

public val Res.string.feature_payments_vpa: StringResource by lazy {
      StringResource("string:feature_payments_vpa", "feature_payments_vpa", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 1169, 92),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1765, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1045, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1065, 76),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1569, 116),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 949, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1041, 76),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 981, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 953, 68),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_payments_history", Res.string.feature_payments_history)
  map.put("feature_payments_inter_bank_transfer_description", Res.string.feature_payments_inter_bank_transfer_description)
  map.put("feature_payments_inter_bank_transfer_title", Res.string.feature_payments_inter_bank_transfer_title)
  map.put("feature_payments_intra_bank_transfer_description", Res.string.feature_payments_intra_bank_transfer_description)
  map.put("feature_payments_intra_bank_transfer_title", Res.string.feature_payments_intra_bank_transfer_title)
  map.put("feature_payments_mobile_number", Res.string.feature_payments_mobile_number)
  map.put("feature_payments_receive", Res.string.feature_payments_receive)
  map.put("feature_payments_request", Res.string.feature_payments_request)
  map.put("feature_payments_select_transfer_type_header", Res.string.feature_payments_select_transfer_type_header)
  map.put("feature_payments_select_transfer_type_subtitle", Res.string.feature_payments_select_transfer_type_subtitle)
  map.put("feature_payments_send", Res.string.feature_payments_send)
  map.put("feature_payments_show_code", Res.string.feature_payments_show_code)
  map.put("feature_payments_transfer_options_title", Res.string.feature_payments_transfer_options_title)
  map.put("feature_payments_vpa", Res.string.feature_payments_vpa)
}
